import React, { useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import WrapperSection from '../components/global/WrapperSection';
import { useAuthContext } from '../auth/useAuthContext';

import ReportsFilterBar, { buildDefaultRange } from '../components/reports/ReportsFilterBar';
import KpiCardsRow from '../components/reports/KpiCardsRow';
import RevenueChart from '../components/reports/RevenueChart';
import OrderStatusBreakdown from '../components/reports/OrderStatusBreakdown';
import PaymentBreakdown from '../components/reports/PaymentBreakdown';
import NewCustomersChart from '../components/reports/NewCustomersChart';
import TopProducts from '../components/reports/TopProducts';
import TopCategories from '../components/reports/TopCategories';
import TopBrands from '../components/reports/TopBrands';
import RecentActivity from '../components/reports/RecentActivity';

const Home = () => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');
    const { user } = useAuthContext() || {};
    const [filter, setFilter] = useState(buildDefaultRange);

    return (
        <WrapperSection>
            <Box sx={{ mb: 1 }}>
                <Typography variant="h5" fontWeight={700}>
                    {isArabic ? 'لوحة التحكم' : 'Dashboard'}
                </Typography>
                {user?.name && (
                    <Typography variant="body2" color="text.secondary">
                        {isArabic ? `مرحباً، ${user.name}` : `Welcome back, ${user.name}`}
                    </Typography>
                )}
            </Box>

            <ReportsFilterBar value={filter} onChange={setFilter} />

            <KpiCardsRow filter={filter} />

            <RevenueChart filter={filter} />

            <Grid container spacing={3} sx={{ mb: 3 }}>
                <Grid item xs={12} md={6}>
                    <OrderStatusBreakdown filter={filter} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <PaymentBreakdown filter={filter} />
                </Grid>
            </Grid>

            <NewCustomersChart filter={filter} />

            <RecentActivity />

            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <TopProducts filter={filter} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TopCategories filter={filter} />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TopBrands filter={filter} />
                </Grid>
            </Grid>
        </WrapperSection>
    );
};

export default Home;
